import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ImpersonationService } from './impersonation.service';

@Component({
  selector: 'prox-impersonate-dialog',
  templateUrl: './impersonate-dialog.component.html',
  standalone: false,
})
export class ImpersonateDialogComponent {
  public imps: ImpersonationService;

  constructor(
    dialogConfig: DynamicDialogConfig,
    private ref: DynamicDialogRef,
  ) {
    this.imps = dialogConfig.data.impersonationService;
  }

  close() {
    this.ref.close();
  }
}
